import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import SVG from 'react-inlinesvg';
import { CloseButton } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar,
} from '../../../../../../../../_metronic/_partials/controls';
import {
  getSelectRow,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
} from '../../../../../../../../_metronic/_helpers';
import * as columnFormatters from '../../../../../../../components/SelectProduct/List/column-formatters';
import css from './style.module.css';

export default function OrderBox(props) {
  const {
    order,
    box,
    isNew,
    createBox,
    deleteBox,
    updateBoxCheck,
    removeBoxItem,
    setError,
  } = props;

  const [ids, setIds] = useState([]);
  const [trackingId, setTrackingId] = useState('');
  const [check, setCheck] = useState(false);
  const [entities, setEntities] = useState([]);
  const columns = [
    {
      dataField: 'icon',
      text: '',
      sort: false,
      formatter: columnFormatters.IconColumnFormatter,
      style: {
        width: '65px',
      },
    },
    {
      dataField: 'name',
      text: 'Name',
      sort: false,
      formatter: columnFormatters.NameColumnFormatter,
    },
    {
      dataField: 'productQuantity',
      text: 'Qty',
      sort: false,
    },
    {
      dataField: 'action',
      text: '',
      formatter: ActionsColumnFormatter,
      headerClasses: 'text-right pr-3',
      style: {
        minWidth: '30px',
        width: '60px',
      },
    },
  ];

  useEffect(() => {
    /* if (isNew) console.log('NewBox:', box);
    else console.log('ExistingBox:', box); */
    setTrackingId(box.trackingId);
    setCheck(box.check);

    let arr = [];
    let arrIds = [];
    let ind = 0;
    if (box.items)
      box.items.map((item) => {
        if (item) {
          arr.push(item);
          arrIds.push(item.productCode);
        }
      });
    setEntities(arr);
    setIds(arrIds);
  }, [box]);

  //console.log('ORDERBOXES.Order: ', order);

  const create = () => {
    let items = [];

    for (let i = 0; i < ids.length; i++) {
      //console.log('ids', i, ids[i]);
      let selected = entities.find((c) => c.id === ids[i]);
      //console.log('Selected: ', selected);
      items.push(selected);
    }
    //console.log('create', items);
    createBox(trackingId, check, items, box.sortNo);
  };
  const close = () => {
    //console.log('Close', trackingId);
    if (trackingId) deleteBox(trackingId, entities);
  };
  const setCheckVal = (e) => {
    //console.log(e);
    setCheck(e);
    if (!isNew) updateBoxCheck(trackingId, e);
  };
  const removeItem = (productCode) => {
    //console.log('removeItem', productCode);
    if (!isNew) {
      let item = box.items.find((i) => {
        if (i.productCode === productCode) return i;
      });
      //console.log('removeItem', trackingId, item);
      removeBoxItem(trackingId, item);
    }
  };
  const handleChange = (event) => {
    setTrackingId(event.target.value);
  };

  function ActionsColumnFormatter(cellContent, row, rowIndex) {
    return isNew ? (
      <></>
    ) : (
      <a
        title='Хасах'
        className='btn btn-icon btn-light btn-hover-danger btn-sm'
        onClick={() => removeItem(row.id)}
      >
        <span className='svg-icon svg-icon-md svg-icon-danger'>
          <SVG src={toAbsoluteUrl('/media/svg/icons/General/Trash.svg')} />
        </span>
      </a>
    );
  }

  return (
    <div
      style={{
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'lightgray',
        margin: '10px',
      }}
    >
      <Card id='orderBoxesCard'>
        <CardHeader title={`Box Items - ${entities.length}`}>
          {/* title={`Box - ${box.trackingId ? box.sortNo : 1}`} */}
          <CardHeaderToolbar>
            <CloseButton onClick={close} />
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div className='form-group row'>
            <div className='col-6'>
              <input
                id='trackid'
                type='text'
                value={trackingId}
                className='form-control form-control-sm'
                onChange={handleChange}
                placeholder='Tracking Id'
                disabled={!isNew}
              />
            </div>
            <div className='col-3.5'>
              <label className={css.container}>
                Каргод бүртгэсэн
                <input
                  type='checkbox'
                  checked={check}
                  onChange={(e) => {
                    setCheckVal(e.target.checked);
                  }}
                />
                <span className={css.checkmark}></span>
              </label>
            </div>
            <div className='col-2.5'>
              {isNew ? (
                <button
                  type='button'
                  className='btn btn-success ml-2'
                  onClick={create}
                >
                  <FormattedMessage id='GENERAL.BUTTON.CREATE' />
                </button>
              ) : (
                <></>
              )}
            </div>
          </div>
          {isNew ? (
            <BootstrapTable
              wrapperClasses='table-responsive'
              classes='table table-head-custom table-vertical-center overflow-hidden'
              bootstrap4
              bordered={true}
              remote
              keyField='productCode'
              data={entities === null ? [] : entities}
              columns={columns}
              //onTableChange={getHandlerTableChange(setQueryParams)}
              selectRow={getSelectRow({
                entities,
                ids,
                setIds,
              })}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          ) : (
            <BootstrapTable
              wrapperClasses='table-responsive'
              classes='table table-head-custom table-vertical-center overflow-hidden'
              bootstrap4
              bordered={true}
              remote
              keyField='productCode'
              data={entities === null ? [] : entities}
              columns={columns}
              //onTableChange={getHandlerTableChange(setQueryParams)}
              /* selectRow={getSelectRow({
              entities,
              ids,
              setIds,
            })} */
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          )}
        </CardBody>
      </Card>
    </div>
  );
}
